module.exports = __webpack_public_path__ + "img/hys-3.14d86c5c.jpg";